export default __webpack_public_path__ + "static/media/code.e3979111.jpg";